import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../../../reducers';
import Utils from '../../../../utils';
import UserAgentUtils from '../../../../utils/userAgent';
import Tooltip from '../../../Tooltip';
import { updateFolderTree } from '../../../../containers/DriveItemList/actions';
import { getMenuButtonIcon } from '../../../../utils/menuManager';
import { UpdateFolderTreeButtonContainer, StyledUpdateFolderTreeButton } from './styles';

interface UpdateFolderTreeHeaderButtonProps {
	isOffline: boolean;
	isBusy: boolean;
	iconSrc: string;
	icon?: string;
	label?: string;
	dispatch: Dispatch<StoreState>;
}

const DEFAULT_ICON = 'iconset_uprez_update_medium';
const LOADING_ICON = 'iconset_loading';

const UpdateFolderTreeHeaderButton = ({
	isOffline,
	isBusy,
	iconSrc,
	icon,
	label,
	dispatch,
}: UpdateFolderTreeHeaderButtonProps) => {
	const tooltipId = Utils.generateId();
	const tooltipLabel = label || 'messages.update_folder_tree';
	const showSpinner = isBusy && !isOffline;
	const displayIcon = showSpinner ? LOADING_ICON : (iconSrc || icon || DEFAULT_ICON);
	const isDisabled = isOffline || isBusy;

	const handleClick = () => {
		if (!isDisabled) {
			dispatch(updateFolderTree(true));
		}
	};

	return (
		<UpdateFolderTreeButtonContainer>
			<StyledUpdateFolderTreeButton
				type="button"
				onClick={handleClick}
				disabled={isDisabled}
				isUpdating={showSpinner}
				isOffline={isOffline}
				data-tip={true}
				data-for={tooltipId}
			>
				{getMenuButtonIcon(displayIcon, DEFAULT_ICON)}
				{UserAgentUtils.isDesktop() && (
					<Tooltip id={tooltipId} text={tooltipLabel} />
				)}
			</StyledUpdateFolderTreeButton>
		</UpdateFolderTreeButtonContainer>
	);
};

export default UpdateFolderTreeHeaderButton;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MenuManager/Header/UpdateFolderTreeButton/index.tsx